/**
 * The pill's doors for the two store panels (composer panels, spec 2026-09-19
 * §3.4): a `history` panel opens the box's history (the ⌃⌃ pattern's other
 * half; the pill IS the open door, so only the level flips) and a `tray`
 * panel opens the Island; each then folds the thread, because the history
 * shows only while the thread is down (BashPill's historyUp) and the words
 * were already said. Keyed on the panel object: a frame is a new object, a
 * re-render is not, so each arrival acts exactly once.
 */
import { useEffect } from "react";
import type { ComposerPanel } from "@bash/shared";
import { useLiveStore } from "@/components/composer/live/liveStore";

export function openPillDoor(kind: "history" | "tray"): void {
  const live = useLiveStore.getState();
  if (kind === "history") {
    // A level, never a toggle: an open history stays open.
    if (!live.historyOpen) live.toggleHistory();
    return;
  }
  live.setTrayOpen(true);
}

export function usePillPanelDoors(
  panels: ComposerPanel[] | undefined,
  dismiss: () => void
): void {
  const history = panels?.find((p) => p.kind === "history") ?? null;
  const tray = panels?.find((p) => p.kind === "tray") ?? null;
  useEffect(() => {
    if (!history) return;
    openPillDoor("history");
    dismiss();
  }, [history, dismiss]);
  useEffect(() => {
    if (!tray) return;
    openPillDoor("tray");
    dismiss();
  }, [tray, dismiss]);
}
